// import { Platform } from "react-native";

//  const injectWebCss = () => {
//   // Only on web
//   if (Platform.OS != "web") return;

//   const webStyleCorrection = `
//     div {
//         display: flex;  /* Set consistent flex display style with RN View */
//         scrollbar-width: thin;
//     }

//     /* This code removed the glow effect on some browser */
//     textarea, select, input, button {
//         -webkit-appearance: none;
//         outline: none!important;
//     }

//     textarea:focus, select:focus, input:focus, button:focus {
//       -webkit-appearance: none;
//       outline: none!important;
//     }
//     `;
//   //@ts-ignore
//   const style = document.createElement("style");
//   style.textContent = webStyleCorrection;
//   //@ts-ignore
//   return document.head.append(style);
// };

// export default injectWebCss();